import { MODULE_NAME } from '@core/constants';

const getPropFromModule = (state, ...props) =>
  state.getIn([MODULE_NAME, 'areas', ...props]);

export default getPropFromModule;
